import React from 'react';
import { Box, Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { useLocalization } from '@/data/Localization';
import { Settings } from '@/data/Settings';
import {
	footerTopSX,
	footerContainerSX,
	footerTypographyUppercaseBaseSX,
} from '@/components/content/Footer/styles/general';
import { DpPaymentMethods } from '@/components/content/Footer/parts/DpPaymentMethods';
import { CopyrightMobile } from '@/components/content/Footer/parts/CopyrightMobile';
import { DownloadOurApp } from '@/components/content/Footer/parts/DownloadOurApp';
import { CallCenterMobile } from '@/components/content/Footer/parts/CallCenterMobile';
import { DpContainer } from '@/components/blocks/DpContainer';
import { FooterLinksMobile } from '@/components/content/Footer/parts/Links';

export const useBreakToMobileFooter = () => useMediaQuery(`(max-width:575px)`);

export const FooterMobile: React.FC<{
	settings: Settings;
}> = ({ settings }) => {
	const footerNLS = useLocalization('Footer');
	const breakToMobileFooter = useBreakToMobileFooter();

	return (
		<Box component="footer">
			<DpContainer withoutmargin framesx={footerContainerSX(settings?.csrSession)}>
				<Grid container spacing={1} sx={footerTopSX}>
					<Grid mt={1} xs={12}>
						<CallCenterMobile breakToMobileFooter={breakToMobileFooter} />
						<Stack>
							<FooterLinksMobile />
						</Stack>
						<Stack
							mt={2.5}
							direction={breakToMobileFooter ? 'column' : 'row'}
							spacing={breakToMobileFooter ? 0 : '10%'}
							justifyContent="space-between"
						>
							<Stack spacing={1}>
								<Typography sx={footerTypographyUppercaseBaseSX}>
									{footerNLS.PaySafely.t()}
								</Typography>
								<DpPaymentMethods />
							</Stack>
							<Stack mt={2.8} spacing={1}>
								<DownloadOurApp />
							</Stack>
						</Stack>
					</Grid>
				</Grid>
			</DpContainer>
			<CopyrightMobile />
		</Box>
	);
};
